export function getHereLeafletTileUrl() {
  const apiKey = process.env.VUE_APP_HERE_API_KEY;
  return `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?apiKey=${apiKey}`;
}

export const HERE_LEAFLET_ATTRIBUTION =
  '&copy; <a href="https://www.here.com/">HERE</a>';
